export default __webpack_public_path__ + "static/media/background-10.8c895f0b.jpg";